import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { FiAuthenticateAgreementComponent } from '@fi-app/authenticate/agreement/agreement.component';
import { AgreementService } from '@fi-app/agreement/agreement.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginConfidentialAgreementState: Ng2StateDeclaration = {
    name: FiStateNames.Login.ConfidentialAgreement,
    url: '/ConfidentialAgreement/:UserPreferredContentLanguageId/:DefaultContentLanguageId',
    component: FiAuthenticateAgreementComponent,
    params: {
        adCredentials: null,
        loginData: null,
        agreementNotAcceptedResponse: null,
    },
    resolve: {
        agreement: [
            AgreementService,
            FiStateService,
            Transition,
            FiAuthStatesLoginConfidentialAgreementResolve_agreement_resolveFunc,
        ],
        pageTitle: [PageTitleService, 'agreement', FiAuthStatesLoginConfidentialAgreementResolve_pageTitle_resolveFunc],
    },
};

export function FiAuthStatesLoginConfidentialAgreementResolve_agreement_resolveFunc(
    agreementService: AgreementService,
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return new Promise((resolve, reject) => {
        if (fiStateService.getParams($transition$).agreementNotAcceptedResponse) {
            agreementService.GetConfidentialAgreement().then(resolve).catch(reject);
        } else {
            reject();
            fiStateService.go(FiStateNames.Login.Auth);
        }
    });
}

export function FiAuthStatesLoginConfidentialAgreementResolve_pageTitle_resolveFunc(
    pageTitleService: PageTitleService,
    agreement,
) {
    return pageTitleService.setTitle('Login Confidential Agreement View - ' + agreement.Name);
}
